import { AnketaAuthUser, hasRolePermission } from "../index";

export * from "./support";

export const getMedocinoSupportPermissions = (
  user: AnketaAuthUser
): boolean => {
  let hasAccess: boolean = false;
  let isAutonubil: boolean = false;
  if (user && user.organization) {
    const orgAttributes = user.organization
      .map((org) => org.attributes)
      .filter(Boolean)
      .reduce((acc, attrs) => ({ ...acc, ...attrs }), {});

    const hasAttribute = (attrKey: string, attrValue?: string) => {
      const valueArray = orgAttributes[attrKey];
      if (!valueArray) return false;
      if (attrValue === undefined) return true;
      return valueArray.includes(attrValue);
    };

    isAutonubil =
      hasAttribute("isAutonubil") && orgAttributes["isAutonubil"][0] === "true";
  }
  if (isAutonubil) {
    hasAccess = hasRolePermission({
      user,
      roles: ["anketa-admin"],
    });
  }

  return hasAccess;
};
